import React from "react";

const Cookies = () => {
  return (
    <div className='piskoti-container'>
      <h1>Stran je namenjena za izobraževalne namene.</h1>
      <h1>Stran uporablja naslednje piškote:</h1>
      <h2>1. začasni (in sejni) ali trajni piškoti</h2>
      <h2>2. piškoti tretjih oseb</h2>

      <p>
        Začasni ali sejni piškoti so uporabljeni le za namene vpisovanja na
        stran (za učitelja). Naloga: Piškotek si zapomni, če se je prijavil
        kakšen uporabnik.
      </p>
      <p>
        Piškoti tretjih oseb zajemajo analitične piškote s strani Firebase in so
        namenjeni monitoringu prometa na strani. (Google platforma).{" "}
      </p>
      <p></p>
    </div>
  );
};

export default Cookies;
